import type { FaireProductEntity } from "../../entity_types/product";

export const p_zx2vcydjys: FaireProductEntity = {
  token: "p_zx2vcydjys",
  type: "product",
  name: "Emotions Stacking Rings",
  brandToken: "b_djgzg75ijy",
  brandName: "Open The Joy",
  imageUrl: "https://cdn.faire.com/fastly/6ac634f3ad72fc11358ab0b34051e52b636c5917a4f7c2739f9f719246cd718e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/611be1e532d34249a8fe3fba5d653489580f901633e46f62affa63df6fb271f4.jpeg",
    "https://cdn.faire.com/fastly/a6ef1203d0f92422661c0f470215e7113f29dcf5cd3f4fb8daf92331a584c6ce.jpeg",
    "https://cdn.faire.com/fastly/a5f40a8dc46c53f17c613bb3e4b59ae81a3a7573937ccb406fb960ab5d2b4d09.jpeg",
    "https://cdn.faire.com/fastly/a75624ab852b533a709f82321632a12a8d34d9c79de82c4aa2b70c5f4b784788.jpeg",
    "https://cdn.faire.com/fastly/93717ea192de886b76f9f8ee04c65c67fa20d3f2156b54154a96396bbe15ad38.jpeg"
  ],
  priceDollars: 18.98,
  description: "Transform playtime into a journey of emotional growth and skill development with Open The Joy’s “Sorting My Emotions” stacking rings. Crafted by child development experts and inspired by Montessori methods, this set of 30 vibrant wooden pieces is designed to enrich imaginative play while fostering emotional intelligence, fine motor skills, and color recognition. Each ring features a unique expression or feeling, inviting kids to explore a wide range of emotions through hands-on play. Perfect for stacking, matching, and creative play, these rainbow rings are not just toys, but tools for building a strong emotional foundation. Explore the joy of learning and emotional exploration with your child today!\n\n\n30pc Rainbow Stacking Toy\nDurable wooden pieces\nTeaches colors, emotions and fine motor skills\nMakes a great gift for ages 12 months and up\n",
  tags: [],
  msrpDollars: 34.63,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:56:05.996Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
